import { render, staticRenderFns } from "./disGoods.vue?vue&type=template&id=0da3ad22"
import script from "./disGoods.vue?vue&type=script&lang=js"
export * from "./disGoods.vue?vue&type=script&lang=js"
import style0 from "./disGoods.vue?vue&type=style&index=0&id=0da3ad22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports